import React, { createContext, useContext, useState } from 'react';

const CityContext = createContext();

export const useCity = () => useContext(CityContext);

export function CityProvider({ children }) {
  const [city, setCity] = useState(() => localStorage.getItem('bv_city') || '');

  const updateCity = (newCity) => {
    setCity(newCity);
    if (newCity) {
      localStorage.setItem('bv_city', newCity);
    } else {
      localStorage.removeItem('bv_city');
    }
  };

  return (
    <CityContext.Provider value={{ city, setCity: updateCity }}>
      {children}
    </CityContext.Provider>
  );
}
